const getters = {
  get_auth: (state) => {
    return state.auth_data;
  },
};
export default getters;
